import React from "react";
export var PegsRedeemed = function PegsRedeemed(_ref) {
  var pegs = _ref.pegs;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card__redeemed"
  }, /*#__PURE__*/React.createElement("h3", null, "Redeemed"), /*#__PURE__*/React.createElement("div", {
    className: "rewardPointsRedeemedBox"
  }, /*#__PURE__*/React.createElement("h3", null, pegs), /*#__PURE__*/React.createElement("h4", null, "pegs")));
};